module.exports = __webpack_public_path__ + "static/media/Supreme Court Seat.aa25a7ec.png";